import { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Initialize EmailJS with public key
      emailjs.init('QcHK1ODt7zDXhI26l');

      // Prepare template parameters
      const templateParams = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        interest: formData.interest || 'Không xác định',
        message: formData.message || 'Không có tin nhắn',
        to_name: 'UPOWER GROUP',
      };

      // Send email using EmailJS
      await emailjs.send(
        'service_ploq3ig', // Replace with your EmailJS service ID
        'template_qzckmm6', // Replace with your EmailJS template ID
        templateParams
      );

      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        interest: '',
        message: '',
      });
    } catch (error) {
      console.error('EmailJS Error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: '📞',
      title: 'Hotline',
      details: ['093 49 26 613 (Chính)', '0945 86 3144 (UMIT)'],
      action: 'tel:0934926613',
    },
    {
      icon: '✉️',
      title: 'Email',
      details: ['admin@upower.vn'],
      action: 'mailto:admin@upower.vn',
    },
    {
      icon: '🌐',
      title: 'Website',
      details: ['upower.vn'],
      action: 'https://upower.vn',
    },
    {
      icon: '📍',
      title: 'Địa chỉ',
      details: [
        'Tầng 2 - Số 9A Phạm Cự Lượng, Phường Tân Sơn Hòa, TP.HCM',
      ],
      action: null,
    },
  ];

  const interests = [
    'Khóa học cá nhân',
    'Đào tạo doanh nghiệp',
    'Coaching 1-1',
    'Chương trình UMIT',
    'Khác',
  ];

  return (
    <section id="contact" className="section-padding bg-gray-50">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            SẴN SÀNG CHO BƯỚC TIẾN
          </h2>
          <p className="text-xl text-primary font-semibold mb-4">
            VƯỢT BẬC CỦA BẠN?
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Hãy để Upower Group đồng hành cùng bạn trên hành trình khai phá tiềm
            năng và đạt được những mục tiêu ý nghĩa trong cuộc sống và sự
            nghiệp.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div id="contact-form" className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Đăng ký tư vấn miễn phí
            </h3>

            <form
              id="contact-form"
              onSubmit={handleSubmit}
              className="space-y-6"
            >
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Họ và tên *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
                  placeholder="Nhập họ và tên của bạn"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
                    placeholder="email@example.com"
                  />
                </div>

                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Số điện thoại *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
                    placeholder="0123 456 789"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="interest"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Quan tâm đến
                </label>
                <select
                  id="interest"
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
                >
                  <option value="">Chọn lĩnh vực quan tâm</option>
                  {interests.map((interest, index) => (
                    <option key={index} value={interest}>
                      {interest}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Tin nhắn
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={8}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
                  placeholder="Chia sẻ thêm về nhu cầu của bạn..."
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full btn-primary text-lg py-4 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? (
                  <div className="flex items-center justify-center">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Đang gửi...
                  </div>
                ) : (
                  'Đăng Ký Tư Vấn Ngay'
                )}
              </button>

              {/* Status Messages */}
              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center">
                    <svg
                      className="w-5 h-5 text-green-500 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <p className="text-green-700 font-medium">
                      Cảm ơn bạn đã liên hệ! Chúng tôi sẽ phản hồi trong thời
                      gian sớm nhất.
                    </p>
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                  <div className="flex items-center">
                    <svg
                      className="w-5 h-5 text-red-500 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <p className="text-red-700 font-medium">
                      Có lỗi xảy ra khi gửi tin nhắn. Vui lòng thử lại hoặc liên
                      hệ trực tiếp qua hotline.
                    </p>
                  </div>
                </div>
              )}
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            {/* Contact Details */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Thông tin liên hệ
              </h3>

              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <div key={index} className="flex items-start">
                    <div className="text-2xl mr-4 mt-1">{info.icon}</div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">
                        {info.title}
                      </h4>
                      {info.details.map((detail, detailIndex) => (
                        <div key={detailIndex}>
                          {info.action ? (
                            <a
                              href={info.action}
                              className="text-primary hover:text-primary-700 font-medium transition-colors duration-200"
                              target={
                                info.action.startsWith('http')
                                  ? '_blank'
                                  : undefined
                              }
                              rel={
                                info.action.startsWith('http')
                                  ? 'noopener noreferrer'
                                  : undefined
                              }
                            >
                              {detail}
                            </a>
                          ) : (
                            <span className="text-gray-700">{detail}</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-gradient-to-r from-primary to-primary-700 rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-6">Liên hệ nhanh</h3>

              <div className="space-y-4">
                <a
                  href="tel:0934926613"
                  className="flex items-center p-4 bg-white/10 backdrop-blur-sm rounded-lg hover:bg-white/20 transition-colors duration-300"
                >
                  <span className="text-2xl mr-4">📞</span>
                  <div>
                    <div className="font-semibold">Gọi ngay</div>
                    <div className="text-primary-100 text-sm">
                      093 49 26 613
                    </div>
                  </div>
                </a>

                <a
                  href="mailto:admin@upower.vn"
                  className="flex items-center p-4 bg-white/10 backdrop-blur-sm rounded-lg hover:bg-white/20 transition-colors duration-300"
                >
                  <span className="text-2xl mr-4">✉️</span>
                  <div>
                    <div className="font-semibold">Gửi email</div>
                    <div className="text-primary-100 text-sm">
                      admin@upower.vn
                    </div>
                  </div>
                </a>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
